"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var Rect_meta_1 = require("./Rect.meta");
var Rect = /** @class */ (function (_super) {
    __extends(Rect, _super);
    function Rect(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = Rect_meta_1.RECT_CATEGORY_KEY;
        _this.componentKey = Rect_meta_1.RECT_COMPONENT_KEY;
        return _this;
    }
    Rect.prototype.render = function () {
        var _a = this.props, className = _a.className, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, _d = _a.rx, rx = _d === void 0 ? 0 : _d, _e = _a.ry, ry = _e === void 0 ? 0 : _e;
        var svgProps = this.getElementSvgProps({
            x: x,
            y: y,
            rx: rx,
            ry: ry,
        });
        return (react_1.default.createElement("rect", __assign({ className: className }, svgProps)));
    };
    Rect = __decorate([
        mobx_react_1.observer
    ], Rect);
    return Rect;
}(shared_1.SvgElement));
exports.Rect = Rect;
exports.default = shared_1.InjectedStyledComponent(Rect, Rect_meta_1.RECT_CATEGORY_KEY, Rect_meta_1.RECT_COMPONENT_KEY);
